// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 12C1 5.92489 5.92486 1 12 1C18.0751 1 23 5.92489 23 12C23 18.0752 18.0751 23.0001 12 23.0001C5.92486 23.0001 1 18.0752 1 12ZM15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12ZM12 4.5H11.5V5.5H12C15.5899 5.5 18.5 8.41015 18.5 12V12.5H19.5V12C19.5 7.85787 16.1421 4.5 12 4.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cd-filled')
export default class CdFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cd-filled',
    }
  }
}
